import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

const RadioInput = ({
  value,
  onChange,
  options = [],
  style,
  className,
  ...props
}) => {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      style={style}
      className={className}
      {...props}
    >
      {options.map((option) => (
        <Radio key={option.value} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

RadioInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default RadioInput; 